import { combineReducers } from "@reduxjs/toolkit";
import globalAppReducer from "./slice/globalAppSlice";
import appReducer from "./slice/appSlice";
import authReducer from "./slice/authSlice";

const rootReducer = combineReducers({
  global: globalAppReducer,
  app: appReducer,
  auth: authReducer,
});

export default rootReducer;
